<template>
 <div class="convertion-points">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">{{ module.Name }}</div>
      </q-card-section>
      <q-separator />

      <q-tabs v-model="tab" class="tab-section">
        <q-tab 
          v-for="convertionSetting in convertionSettings"
          :key="convertionSetting.ID"
          :name="convertionSetting.Action"
          :label="convertionSetting.Name"
          @click="tabChange(convertionSetting)"
        />
      </q-tabs>
      <q-card-section class="card-content">
        <div class="convert-description">
          For this convertion of {{ convertion.typeFrom }} to {{ convertion.typeTo }} in Every {{ convertion.setting }}
          you will get {{ convertion.convertionPoint + convertion.typeTo }}
        </div>
        <div class="convert-description">
          Your Current {{ convertion.typeFrom }} {{ convertion.currentPoints }}
        </div>
        <div class="convert-description">
          You can convert point if you have character/s with minimum level of {{ convertion.ChaMinLevel }}
        </div>
        <div class="convert-description">
          After convertion you will get {{ Math.trunc(convertion.pointsGet) + convertion.typeTo }}
        </div>
        <q-btn class="convert-btn" label="Convert" @click="convert()" :disable="convertion.pointsGet === 0"/>
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'ConvertPoints',
  props: {
    module: {
      require: true,
      type: Object
    }
  },
  data () {
    return {
      tab: '',
      selectedTab: {},
      captcha: null,
      convertion: {
        convertionPoint: 0,
        pointsGet: 0,
        setting: '0',
        typeFrom: '',
        typeTo: '',
        currentPoints: 0
      },
    }
  },
  computed: {
    ...mapGetters({
      convertionSettings: 'panel/getPointsConvertion',
      user: 'user/getUser'
    })
  },
  async mounted () {
    this.$q.loading.show()

    // retrieve updated data
    await this.getAuthUser()

    await this.requestConvertionSettings()

    this.tabChange(this.convertionSettings[0])

    this.tab = this.convertionSettings[0].Action

    this.setupCaptcha ()

    this.$q.loading.hide();
  },
  methods: {
    ...mapActions({
      requestConvertionSettings: 'panel/requestConvertionSettings',
      getAuthUser: 'user/getAuthUser',
      convertPoints: 'panel/convertPoints'
    }),
    async setupCaptcha () {
      await this.$recaptchaLoaded()

     this.captcha = await this.$recaptcha('convertion')
    },
    convert () {
      this.$q.loading.show();

      const param = {
        captcha: this.captcha,
        id: this.selectedTab.ID
      }

      this.convertPoints(param)
        .then(async () => {
          this.$q.notify({
            position: 'top-right',
            message: 'Convertion Success',
            type: 'positive'
          })

          await this.getAuthUser();
          
          this.tabChange(this.selectedTab)

          this.setupCaptcha ()

          this.$q.loading.hide()
        })
        .catch((error) => {
          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative'
          })

          this.setupCaptcha ()

          this.$q.loading.hide();
        })
    },
    tabChange(tab) {
      const { ConvertionTime, PointsConvertion, DBColumnFrom, ChaMinLevel } = tab

      this.selectedTab = tab

      const basisConvertion = this.user[DBColumnFrom]

      this.convertion.convertionPoint = PointsConvertion
      this.convertion.currentPoints = basisConvertion
      this.convertion.ChaMinLevel = ChaMinLevel

      if (ConvertionTime.includes('M')) {
        const minute = ConvertionTime.replace('M','')
        this.convertion.setting = minute + ' Minutes'

        this.convertion.pointsGet = Math.trunc(basisConvertion / minute) * PointsConvertion

        this.convertion.typeTo = tab.Action === 'gt2ep' ? 'EP' : 'GT'
        this.convertion.typeFrom = 'Game Time'
      } else if (ConvertionTime.includes('H')) {
        const hours = ConvertionTime.replace('H','')
        const minute = hours * 60;

        this.convertion.setting = minute + ' Minutes'
        this.convertion.pointsGet = Math.trunc(basisConvertion / minute) * PointsConvertion

        this.convertion.typeTo = tab.Action === 'gt2ep' ? 'EP' : 'GT'
        this.convertion.typeFrom = 'Game Time'
      } else if (ConvertionTime.includes('GT')) {
        const vp = ConvertionTime.replace('GT','')
        this.convertion.setting = vp + ' GT'

        this.convertion.pointsGet = Math.trunc(basisConvertion / vp) * PointsConvertion
        
        this.convertion.typeTo = 'EP'
        this.convertion.typeFrom = 'GT'
      } else if (ConvertionTime.includes('EP')) {
        const ep = ConvertionTime.replace('EP','')
        this.convertion.setting = ep + ' EP'

        this.convertion.pointsGet = Math.trunc(basisConvertion / ep) * PointsConvertion

        this.convertion.typeTo = 'GT'
        this.convertion.typeFrom = 'EP'
      }
    }
  }
}
</script>
<style lang="scss">
.convertion-points {
  .my-card {
    background-color: $backgroundHeader;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .card-section {
      color: white;
    }

    .tab-section {
      background-color: $background;
      color: white;
    }

    .card-content {
      background-color: $background;
      display: grid;
      grid-template-rows: 1fr 1fr;
      gap: 16px;
    }

    .convert-description {
      color: white;
    }

    .convert-btn {
      background-color: #FFC108;
    }
  }

  .q-layout__section--marginal {
    background-color: $background;
  }
  
  .q-tab__label {
    color: white;
  }

  .q-tab {
    margin-left: 20px;
    margin-right: 20px;
  }
}
</style>